import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import Datepicker from 'vanillajs-datepicker/Datepicker';
import {$events} from "../helpers/events";

import ru from 'vanillajs-datepicker/locales/ru';
import variables from "../variables";
Object.assign(Datepicker.locales, ru);

const {addClass, removeClass, get} = $dom

const groupSelector = '.js-calendar-group'
const inputSelector = '.js-calendar-input-blocked'

const toggleViewButtonSelector = '.js-datepicker-toggle-view'

const {classNames} = variables

const activeClass = 'is-filled-calendar'

export default function () {
    const handleFocus = e => {
        addClass(e.target, activeClass)
        addClass(toggleViewButtonSelector, classNames.active)
    }


    const handleBlur = e => {
        if (e.target.value.length === 0) {
            removeClass(e.target, activeClass)
        }

        removeClass(toggleViewButtonSelector, classNames.active)
    }

    return new Component({
        name: 'calendar',
        requiredTargets: [groupSelector, inputSelector, toggleViewButtonSelector],
        onInit() {
            new Datepicker(get(inputSelector), {
                language: 'ru'
            })

            $events
                .add('focus', inputSelector, handleFocus)
            $events
                .add('blur', inputSelector, handleBlur)
        },
        onDestroy() {
            $events
                .remove('focus', inputSelector, handleFocus)
                .remove('blur', inputSelector, handleBlur)
        },
    })

};